import { Colors, Text } from '@amelio/ui-library';

import {
    GROWTH_BLOCK_SURFACE,
    GROWTH_CAPTION,
    GROWTH_FIELD_LABEL,
    GROWTH_QUESTION_TITLE,
} from './careerAspirationStyles';

import type { ReactNode } from 'react';

interface AspirationQuestionBlockProps {
    title: string;
    caption?: string;
    className?: string;
    dataTestId?: string;
    children: ReactNode;
}

/** One question of the meeting, on the same panel the results section uses. */
export const AspirationQuestionBlock = ({
    title,
    caption,
    className = GROWTH_BLOCK_SURFACE,
    dataTestId,
    children,
}: AspirationQuestionBlockProps) => (
    <div
        className={className}
        data-testid={dataTestId}
    >
        <div className={'flex flex-col gap-1'}>
            <h4 className={GROWTH_QUESTION_TITLE}>{title}</h4>
            {caption && <span className={GROWTH_CAPTION}>{caption}</span>}
        </div>
        {children}
    </div>
);

interface AspirationFollowUpProps {
    label: ReactNode;
    hint?: string;
    children: ReactNode;
}

/** A follow-up inside a question: its label, the field, and an optional hint under it. */
export const AspirationFollowUp = ({ label, hint, children }: AspirationFollowUpProps) => (
    <div className={'flex flex-col gap-1.5'}>
        {label}
        {children}
        {hint && <span className={GROWTH_CAPTION}>{hint}</span>}
    </div>
);

/** The label of a follow-up that names no single input, such as a group of chips. */
export const FollowUpLabel = ({ children }: { children: string }) => (
    <Text
        color={Colors.NAVY}
        className={GROWTH_FIELD_LABEL}
    >
        {children}
    </Text>
);
